class FilterFacet extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onSummaryEnter = this.onSummaryEnter.bind(this)
    this.onSummaryLeave = this.onSummaryLeave.bind(this)

    this.listeners.add(this, 'mouseenter', this.onSummaryEnter)
    this.listeners.add(this, 'mouseleave', this.onSummaryLeave)
  }

  onSummaryEnter () {
    this.content.setAttribute('aria-hidden', 'false')
  }

  onSummaryLeave () {
    this.content.setAttribute('aria-hidden', 'true')
  }

  get content () {
    return window.BAO.Utils.getElement(this.els.content.selector, {
      context: this,
    })
  }
}

if (!customElements.get('filter-facet')) {
  customElements.define('filter-facet', FilterFacet)
}
